import createIcon from '../../createIcon';

/**
 * @component @name Report
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuNzMgM0g4LjI3TDMgOC4yN1YxNS43M0w4LjI3IDIxSDE1LjczTDIxIDE1LjczVjguMjdMMTUuNzMgM1pNMTIgMTcuM0MxMS4yOCAxNy4zIDEwLjcgMTYuNzIgMTAuNyAxNkMxMC43IDE1LjI4IDExLjI4IDE0LjcgMTIgMTQuN0MxMi43MiAxNC43IDEzLjMgMTUuMjggMTMuMyAxNkMxMy4zIDE2LjcyIDEyLjcyIDE3LjMgMTIgMTcuM1pNMTMgMTNIMTFWN0gxM1YxM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Report = createIcon('Report', [
  [
    'path',
    {
      d: 'M15.73 3H8.27L3 8.27V15.73L8.27 21H15.73L21 15.73V8.27L15.73 3ZM12 17.3C11.28 17.3 10.7 16.72 10.7 16C10.7 15.28 11.28 14.7 12 14.7C12.72 14.7 13.3 15.28 13.3 16C13.3 16.72 12.72 17.3 12 17.3ZM13 13H11V7H13V13Z',
      key: 'u78l8h',
    },
  ],
]);

export default Report;
